import {AuthService} from "./AuthService";

export class ExportAsyncService {
    queueUrl = `queues/`;
    reportUrl = `product_generated_reports/`;
    postfix = `_generated_report`;

    exportDetailedProductList(campaign_id, startDate, endDate) {
        let body = {process_type: "detailed_product_list" + this.postfix, param: {campaign_id: campaign_id, start_date: startDate, end_date: endDate}};
        return AuthService.apiPost(this.queueUrl, body).then(res => res.data.data);
    }

    exportCompetitorPriceHistory(campaign_id, startDate, endDate) {
        let body = {process_type: "competitor_price_history" + this.postfix, param: {campaign_id: campaign_id, start_date: startDate, end_date: endDate}};
        return AuthService.apiPost(this.queueUrl, body).then(res => res.data.data);
    }

    exportCategoryPriceComparison() {
        // Account level report: it spans every campaign of the user, so it
        // carries no campaign_id.
        let body = {process_type: "category_price_comparison" + this.postfix, param: {}};
        return AuthService.apiPost(this.queueUrl, body).then(res => res.data.data);
    }

    exportCategoryPriceComparisonWeekly(days) {
        let body = {process_type: "category_price_comparison_weekly" + this.postfix, param: {days: days}};
        return AuthService.apiPost(this.queueUrl, body).then(res => res.data.data);
    }

    exportProductSuggestions(campaign_id) {
        let body = {process_type: "product_suggestions" + this.postfix, param: {campaign_id: campaign_id}};
        return AuthService.apiPost(this.queueUrl, body).then(res => res.data.data);
    }

    // Re-queues a report that failed, from the process type and parameters the
    // original record kept. The queue endpoint re-checks the entitlement, so
    // this is the same door the report screens go through.
    retryGeneratedReport(process_type, param) {
        let body = {process_type: process_type + this.postfix, param: param || {}};
        return AuthService.apiPost(this.queueUrl, body).then(res => res.data.data);
    }

    listGeneratedReports(){
        return AuthService.apiGet(this.reportUrl + "list_generated_reports/").then(res => res.data.data);
    }

    downloadGeneratedReport(report_key){
        return AuthService.apiGet(this.reportUrl + "download_generated_report/",{responseType: 'blob', params: {report_key: report_key}}).then(res => res);
    }
}
